module.exports = __webpack_public_path__ + "static/media/IMG_20180808_202444.808bf55d.jpg";